<template>
  <div class="o-form">
    <div v-if="loading" class="c-alert">
      <Spinner />
      Data ophalen bij POM<br />
      <p v-if="attempts > 2">
        Even geduld a.u.b. Klik deze pagina niet weg.
      </p>
    </div>
    <h2 v-if="!loading && !error" class="c-alert c-alert--success">Data ophalen gelukt</h2>
    <div v-if="error" class="c-alert c-alert--danger">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { useConfig } from "@/app-config";
import { useAxios } from "@/infrastructure/api-axios";
import { details as getOrder } from "@/infrastructure/order-functions";

import { useRouter } from "vue-router";
import { ref } from "vue";

export default {
  setup() {
    const loading = ref(true);
    const error = ref("");
    const attempts = ref(0);

    const apiAxios = useAxios();
    const router = useRouter();

    const { paymentEntryUrl, processPomPaymentUrl, baseUrl } = useConfig();
    const processPayment = async (paymentId) => {
      const url = processPomPaymentUrl.replace("{paymentId}", paymentId + "");
      const response = await apiAxios.post(url);
      if (response.status === 200) {
        return response.data;
      }
      return null;
    };

    const tryLoadOrder = async ({ appId, orderId, paymentId }) => {
      attempts.value++;
      const order = await getOrder(orderId, appId);
      if (order != null) {
        if (order.paymentStatus != null) {
          return order;
        } else if (attempts.value < 10) {
          return new Promise((resolve) => {
            setTimeout(async () => {
              const order2 = await tryLoadOrder({ appId, orderId, paymentId });
              resolve(order2);
            }, 1000 * (1 + attempts.value * 0.1));
          });
        } else {
          if (paymentId) {
            await processPayment(paymentId);
            return tryLoadOrder({ appId, orderId, paymentId });
          }
        }
      }
      return null;
    };
    const findPaymentEntry = async (paymentId) => {
      const pomProvider = 1;
      const url = `${paymentEntryUrl.replace("{paymentId}", paymentId + "").replace("{provider}", pomProvider)}`;
      const response = await apiAxios.get(url);
      if (response.status === 200) {
        const paymentEntry = response.data;
        const order = await tryLoadOrder({ ...paymentEntry, paymentId });
        if (order == null) {
          throw Error("InvalidPaymentStatus");
        }
        return paymentEntry;
      }
    };

    const init = async () => {
      const route = router.currentRoute.value;
      const pomPaymentId = route.query.documentId;
      const pomResponseCode = route.query.responseCode;

      let paymentEntry = null;
      try {
        paymentEntry =
          pomResponseCode != "00"
            ? // update paymentStatus
              await processPayment(pomPaymentId)
            : // get paymentEntry and check order paymentStatus
              await findPaymentEntry(pomPaymentId);
      } catch (ex) {
        console.error("Fetching paymentEntry failed", { pomPaymentId, ex });
      } finally {
        setTimeout(() => (loading.value = false), 500);
      }

      if (paymentEntry != null) {
        const { appId, orderId } = paymentEntry;
        const newRoute = router.resolve({ name: "bevestiging", query: { appId, orderId } });
        location.href = baseUrl + newRoute.fullPath;
      } else {
        error.value = "Ophalen data bij POM is mislukt";
      }
    };

    init();

    return {
      loading,
      error,
      attempts,
    };
  },
};
</script>
